import { PLAN_GROUP_IDS, PLAN_RESTRUCTURE_EXPERIMENT_GROUP_IDS } from './constants';
import type { PlanDetail } from '../../repositories/account-repo';

const MICRO_EMAIL_PLAN_GROUP_SUBTYPE = 'MICRO_EMAIL';

export class PlanDetailVO {
  constructor(private apiResponse: PlanDetail) {}

  public getPlanGroupId(): number {
    return this.apiResponse.planGroupId;
  }

  public isInTrial(): boolean {
    return this.apiResponse.inTrial;
  }

  /**
   * Whether to fetch upgrade-plan-promotion for Micro Email STP (paid).
   * Active trial users are excluded unless Stripe (stale inTrial after FTP).
   */
  public shouldFetchMicroEmailPromotion(isStripeUser: boolean): boolean {
    if (!this.isMicroEmail()) {
      return false;
    }

    return isStripeUser || !this.isInTrial();
  }

  public isAuOrNz(): boolean {
    return this.isAustralianPlanGroup() || this.isNewZealandPlanGroup();
  }

  public isAustralianPlanGroup(): boolean {
    return this.apiResponse.planGroupId === PLAN_GROUP_IDS.AUSTRALIA_V1;
  }

  public isNewZealandPlanGroup(): boolean {
    return this.apiResponse.planGroupId === PLAN_GROUP_IDS.NEW_ZEALAND_V1;
  }

  public isCharmPricing(): boolean {
    return this.apiResponse.planGroupId === PLAN_GROUP_IDS.MWEB_CHARM_PRICING;
  }

  public isPlanRestructureExperiment(): boolean {
    return PLAN_RESTRUCTURE_EXPERIMENT_GROUP_IDS.includes(this.apiResponse.planGroupId);
  }

  public isMicroEmail(): boolean {
    return this.apiResponse.planGroupSubType === MICRO_EMAIL_PLAN_GROUP_SUBTYPE;
  }

  /**
   * Whether to fetch upgrade-plan-promotion to obtain a recommended 3PL plan group ID.
   * True for: Micro Email (paid or Stripe trial) OR legacy plan groups on Stripe accounts.
   * The promotion API returns a 3PL group (e.g. 109) so the new payflow can render
   * Bronze/Silver/Gold plan cards instead of unsupported legacy plan types.
   * `isLegacyPlanGroup` comes from the user's own plan group (see useIsLegacyPlanGroup).
   */
  public shouldFetch3PlPromotion(isStripeUser: boolean, isLegacyPlanGroup: boolean): boolean {
    if (this.isMicroEmail()) {
      return isStripeUser || !this.isInTrial();
    }

    // Legacy Stripe accounts always need the 3PL group override for plan card rendering.
    return isStripeUser && isLegacyPlanGroup;
  }
}
